import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import { useLocale } from "@/hooks/useLocale";
import { Form } from "@/ui/Form";
import { Col } from "react-bootstrap";

export const IR35PageContentSection = ({ className }) => {
  const locale = useLocale();

  return (
    <SeriousAboutTalent
      className={className}
      tag={`page.ir35.content.tag.${locale}`}
      title={`page.ir35.content.title.${locale}`}
      text={`page.ir35.content.text.${locale}`}
      details={`page.ir35.content.details.${locale}`}
    >
      <Col xs={12} lg={6}>
        <div className="bg-secondary text-white p-4 pb-2 mt-4 mt-lg-0 ms-0 ms-lg-5">
          <a id="contactUs" />
          <Form formId="0c293198-9647-48a1-962f-5cb6d6bfb206" />
        </div>
      </Col>
    </SeriousAboutTalent>
  );
};
